export const dividerSvg = `<svg width="7" height="32" viewBox="0 0 7 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="3.5" y1="32" x2="3.5" y2="4" stroke="#BFC4CF"/></svg>`;
